"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsService = void 0;
const client_sdk_common_1 = require("@easygenerator/client-sdk.common");
const segment_provider_1 = __importDefault(require("./providers/segment-provider"));
const console_provider_1 = __importDefault(require("./providers/console-provider"));
const native_mixpanel_provider_1 = __importDefault(require("./providers/native-mixpanel-provider"));
const productfruit_provider_1 = __importDefault(require("./providers/productfruit-provider"));
const ENABLE_ANALYTICS_COOKIE_NAME = 'enable_analytics';
class AnalyticsService {
    constructor(analyticsOptions) {
        var _a, _b, _c;
        this.providerList = [];
        if (analyticsOptions.isDev === true) {
            const consoleProvider = new console_provider_1.default();
            this.providerList.push(consoleProvider);
            return;
        }
        if (!this.isAnalyticsEnabled(analyticsOptions.analyticsEnabled)) {
            console.log(`[analytics] Analytics disabled for this environment. Update environment configuration to change this.`);
            return;
        }
        if (analyticsOptions.segmentWriteKey) {
            const { segmentWriteKey, mixpanel } = analyticsOptions;
            const segmentProvider = new segment_provider_1.default({ segmentWriteKey, mixpanel });
            this.providerList.push(segmentProvider);
        }
        else {
            console.warn('Invalid segmentWriteKey');
        }
        if (((_a = analyticsOptions.nativeMixpanel) === null || _a === void 0 ? void 0 : _a.projectId) && ((_b = analyticsOptions.nativeMixpanel) === null || _b === void 0 ? void 0 : _b.projectName)) {
            const nativeMixpanelProvider = new native_mixpanel_provider_1.default(analyticsOptions.nativeMixpanel);
            this.providerList.push(nativeMixpanelProvider);
        }
        else {
            console.warn('Native Mixpanel projectId or projectName is not configured');
        }
        if ((_c = analyticsOptions.productFruit) === null || _c === void 0 ? void 0 : _c.projectCode) {
            const productFruitProvider = new productfruit_provider_1.default({
                projectCode: analyticsOptions.productFruit.projectCode,
                language: analyticsOptions.productFruit.language,
                options: analyticsOptions.productFruit.options
            });
            this.providerList.push(productFruitProvider);
        }
    }
    identify(identity) {
        if (identity.hasOwnProperty('id')) {
            identity.id = (0, client_sdk_common_1.toShortGuid)(identity.id);
        }
        this.providerList.forEach(provider => {
            provider.identify(identity);
        });
    }
    updateIdentity(data) {
        if (!data.id) {
            throw Error("Data doesn't have an id");
        }
        data.id = (0, client_sdk_common_1.toShortGuid)(data.id);
        this.providerList.forEach(provider => {
            provider.updateIdentity(data);
        });
    }
    trackEvent(eventName, category, properties) {
        this.providerList.forEach(provider => {
            provider.trackEvent(eventName, category, properties);
        });
    }
    logout() {
        this.providerList.forEach(provider => {
            provider.logout();
        });
    }
    trackPage() {
        this.providerList.forEach(provider => {
            provider.trackPage();
        });
    }
    isAnalyticsEnabled(analyticsEnabled) {
        if (window.Cypress || (0, client_sdk_common_1.getCookie)(ENABLE_ANALYTICS_COOKIE_NAME) === 'false') {
            return false;
        }
        return !!((0, client_sdk_common_1.getCookie)(ENABLE_ANALYTICS_COOKIE_NAME) === 'true' || analyticsEnabled);
    }
}
exports.AnalyticsService = AnalyticsService;
